import { render, staticRenderFns } from "./UserSettingsGeneral.vue?vue&type=template&id=4823dd49"
import script from "./UserSettingsGeneral.vue?vue&type=script&lang=js"
export * from "./UserSettingsGeneral.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsGeneral.vue?vue&type=style&index=0&id=4823dd49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports